const BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:3001'

function getToken(): string | null {
  return localStorage.getItem('velink_token')
}

export async function apiFetch<T = unknown>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const token = getToken()

  const hasBody = options.body !== undefined && options.body !== null
  const res = await fetch(`${BASE}/api${path}`, {
    ...options,
    headers: {
      ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  })

  if (res.status === 401) {
    localStorage.removeItem('velink_token')
    window.location.href = '/connexion'
    throw new Error('Session expirée')
  }

  if (res.status === 204) return undefined as T

  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error((data as { message?: string }).message ?? `Erreur ${res.status}`)
  }

  return res.json() as Promise<T>
}
